import "../../../../content/posts/how-letterboxd-creates-pixelated-skeleton-images/app.css";
import * as React from 'react';
export default {
  React
};